import React from 'react';
import { Link } from 'react-router-dom';
import './styles.css';

// Material
import Container from '@material-ui/core/Container';

const Header = () => {
  return (
    <header className="header">
      <Container>
        <Link to="/">
          <h2>NAEXGUIDE</h2>
        </Link>
        <nav>
          <Link to="/about">About</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/privacy-policy">Privacy policy</Link>
        </nav>
      </Container>
    </header>
  );
};

export default Header;
